import Cookies from 'js-cookie'
import { fetchContentApi } from '../../services/content-api'

export const fetchTutorialStepsApi = async (tutorialId, language, customer) => {
  return fetchContentApi(
    `/tutorialsteps?language=${language}&tutorialId=${String(
      tutorialId
    )}&customer=${customer}`
  )
}

export const fetchTutorialListApi = async (
  currentPhoneId,
  preSaleFlag,
  language,
  customer
) => {
  const preSaleURL = preSaleFlag ? '&presales=1' : ''
  const showHidden = Cookies.get('showHiddenTutorials')
    ? '&includeHidden=1'
    : ''
  return fetchContentApi(
    `/tutorials?language=${language}&phoneId=${currentPhoneId}` +
      `&customer=${customer}${preSaleURL}${showHidden}`
  )
}



// WEBPACK FOOTER //
// ./src/containers/Tutorials/services.js